export const amounts = {
    IN: "999",
    otherCountry: 12
};

export const BasicPlanData = {
    IN: [
        "One time 1000 free Messages (exclusively for Basic Plan users)",
        "Generate, capture & track your potential leads",
        "Lead generation, capture, and tracking",
        "WhatsApp Broadcast - Analytics upto 5 Campaigns",
        "One bot flow",
        "Bulk customer upload"
    ],
    otherCountry: [
        "One time 1000 free Messages (exclusively for Basic Plan users)",
        "Whatsapp business API & Integration",
        "Lead generation, capture, and tracking",
        "WhatsApp Broadcast - Analytics upto 5 Campaigns",
        "One bot flow",
        "Bulk customer upload"
    ]
};

export const conversationTexts = {
    IN: "Conversation charges: As per Meta rates",
    otherCountry: "Conversation charges: As per Meta rates"
};
